import React from "react";
// import { useLocation, useNavigate } from "react-router-dom";
import { AppBar, Toolbar, Box } from "@mui/material";

import { ModeChangebar } from "./ModeChangebar";

export const Topbar = () => {
  // const location = useLocation();
  // const navigate = useNavigate();

  return (
    <AppBar
      position="static"
      sx={{
        boxShadow: 0,
        padding: 4,
      }}
    >
      <Toolbar>
        <Box flexGrow={1} display="flex"></Box>
        <ModeChangebar />
      </Toolbar>
    </AppBar>
  );
};
